import { defineNuxtRouteMiddleware, useRuntimeConfig, } from "nuxt/app";

const APP_VERSION_KEY = "appVersion";

export default defineNuxtRouteMiddleware(() => {
  const storedVersion = localStorage.getItem(APP_VERSION_KEY);
  const current = String(useRuntimeConfig().public.appVersion);

  if (storedVersion !== current) {
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem(APP_VERSION_KEY, current);
  }

  return;
})